import { __assign } from "tslib";
import { createHttpTestKit } from '../../http/test-kit';
import { createFakePostResponder } from '../../test-utils';
import { createChatInsightsApi } from './';
export var createChatInsightsApiTestkit = function (parent) {
    if (parent === void 0) { parent = 'localhost'; }
    var fakeHttp = createHttpTestKit();
    var api = createChatInsightsApi(parent, fakeHttp);
    var base = parent + "/analytics/chat";
    var handler = {
        whenGetOverview: createFakePostResponder(fakeHttp, base + "/overview"),
        whenGetNumericComparison: createFakePostResponder(fakeHttp, base + "/overviewTables/chat"),
        whenGetServedChatHistogram: createFakePostResponder(fakeHttp, base + "/servedChats/histogram"),
        whenGetServedChatCumuative: createFakePostResponder(fakeHttp, base + "/servedChats/cumulative"),
        whenGetTimeToEndChatHistogram: createFakePostResponder(fakeHttp, base + "/timeToEndChat/histogram"),
        whenGetTimeToEndChatCumuative: createFakePostResponder(fakeHttp, base + "/timeToEndChat/cumulative"),
        whenGetNewChatsHistogram: createFakePostResponder(fakeHttp, base + "/newChats/histogram"),
        whenGetNewChatsCumuative: createFakePostResponder(fakeHttp, base + "/newChats/cumulative"),
        whenGetFirstResponseTimeHistogram: createFakePostResponder(fakeHttp, base + "/firstResponseTime/histogram"),
        whenGetFirstResponseTimeCumuative: createFakePostResponder(fakeHttp, base + "/firstResponseTime/cumulative"),
        whenGetChatRepliesHistogram: createFakePostResponder(fakeHttp, base + "/chatReplies/histogram"),
        whenGetChatRepliesCumuative: createFakePostResponder(fakeHttp, base + "/chatReplies/cumulative"),
        whenGetSatisfactionScoreCumulative: createFakePostResponder(fakeHttp, base + "/satisfactionRate/cumulative"),
        whenGetSatisfactionScoreHistogram: createFakePostResponder(fakeHttp, base + "/satisfactionRate/histogram"),
        whenGetChatServieLevel: createFakePostResponder(fakeHttp, base + "/chatServiceLevel"),
    };
    return __assign(__assign({}, api), handler);
};
//# sourceMappingURL=testkit.js.map